import React from 'react';
import './App.css';
import {ThemeProvider} from '@material-ui/core/styles';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import red from '@material-ui/core/colors/red';
import {grey, purple} from "@material-ui/core/colors/";
import ResponsiveDrawer from "./ResponsiveDrawer";
import {ContextProvider} from "./ContextProvider";
import './i18n';


// All the following keys are optional.
// We try our best to provide a great default value.
const theme = createMuiTheme({
    primary: {main: "#a4c753"}, // Purple and green play nicely together.
    secondary: {main: "#f0c64d"}, // This is just green.A700 as hex.

    palette: {
        primary: {main: "#a4c753"}, // Purple and green play nicely together.
        secondary: {main: "#f0c64d"}, // This is just green.A700 as hex.
    },
    overrides: {
        MuiListItem: {
            root: {
                paddingTop: 3,
                paddingBottom: 3,
            }
        }
    },
    typography: {useNextVariants: true},
});


function App(props) {
    var style = {flexGrow: 1}


    return <ContextProvider>
        <ThemeProvider theme={theme}>
            <ResponsiveDrawer/>
        </ThemeProvider>
    </ContextProvider>
}

export default App;
